import type { NotificationFilterKey } from './NotificationRow'

interface NotificationFiltersProps {
  value: NotificationFilterKey
  onChange: (value: NotificationFilterKey) => void
  unreadCount: number
}

export function NotificationFilters({ value, onChange, unreadCount }: NotificationFiltersProps) {
  const filters: { key: NotificationFilterKey; label: string }[] = [
    { key: 'all', label: 'All' },
    { key: 'unread', label: unreadCount > 0 ? `Unread · ${unreadCount}` : 'Unread' },
    { key: 'rsvps', label: 'RSVPs' },
    { key: 'new_events', label: 'New events' },
    { key: 'reminders', label: 'Reminders' },
  ]

  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {filters.map(({ key, label }) => {
        const active = value === key
        return (
          <button
            key={key}
            onClick={() => onChange(key)}
            style={{
              height: 32,
              padding: '0 14px',
              borderRadius: 999,
              border: active ? 'none' : '1.5px solid var(--line)',
              background: active ? 'var(--ink)' : 'transparent',
              color: active ? '#fff' : 'var(--ink-2)',
              fontSize: 13,
              fontWeight: active ? 600 : 500,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
